import type { RoleId } from '@/config/roles';
import { ROLES } from '@/config/roles';

/**
 * Logged-in upsell CTAs are only intended for student users on free plan.
 */
export function shouldShowAuthenticatedUpsell(
  userRole: RoleId,
  isFree: boolean
): boolean {
  return userRole === ROLES.USER && isFree === true;
}

interface PracticeUpsellOptions {
  demoMode?: boolean;
  userRole: RoleId;
  isFree: boolean;
}

/**
 * Demo flows should still show upsell prompts regardless of role.
 */
export function shouldShowPracticeUpsell({
  demoMode = false,
  userRole,
  isFree,
}: PracticeUpsellOptions): boolean {
  return demoMode || shouldShowAuthenticatedUpsell(userRole, isFree);
}
